/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { Page, Layout, TextStyle, Banner, Stack, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { StepProgress } from 'src/components/views/theme-upgrade/step-progress';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { getThemeReviewUrl } from 'src/helpers';
import SendRequestFeatureModal from 'src/components/containers/common/send-request-feature-modal';
import RequestResultModal from 'src/components/containers/theme-upgrade/request-result-modal.jsx';

type Props = {};

type ComposedProps = Props & WithI18nProps;

class ThemeUpgradeSuccess extends Component<ComposedProps> {
  state = {
    activeRequestModal: false,
    activeResultModal: false
  };
  render() {
    const themeName = _.get(this.props.location, 'state.themeName', '');
    const { i18n } = this.props;
    const { activeRequestModal, activeResultModal } = this.state;

    return (
      <div className="BC-Page BC-Page_Success">
        <Page
          title={i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.title')}
          primaryAction={<StepProgress step={2} />}>
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                <Banner
                  title={
                    <span>
                      {i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.upgradeSuccess', {
                        nt_theme_name: <TextStyle variation="strong">{themeName}</TextStyle>
                      })}
                    </span>
                  }
                  status="success"
                  action={{
                    content: i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.preview'),
                    onAction: this.handlePreview
                  }}>
                  <Stack vertical={true}>
                    <TextStyle>
                      {i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.content01', {
                        nt_theme_name: <TextStyle variation="strong">{themeName}</TextStyle>
                      })}
                    </TextStyle>
                    <TextStyle>
                      {i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.content02', {
                        t1: (
                          <TextStyle variation="strong">
                            {i18n.translate(
                              'AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.content02_t1'
                            )}
                          </TextStyle>
                        ),
                        t2: (
                          <TextStyle variation="strong">
                            {i18n.translate(
                              'AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.content02_t2'
                            )}
                          </TextStyle>
                        ),
                        t3: (
                          <Link external url={URL.PublishThemeDoc}>
                            {i18n.translate(
                              'AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.content02_t3'
                            )}
                          </Link>
                        )
                      })}
                    </TextStyle>
                    <TextStyle>
                      {i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.contact', {
                        t: (
                          <Link onClick={this.handleToggleRequestModal}>
                            {i18n.translate('AdminHTML.ThemeUpgrade.ThemeUpgradeSuccess.contact_t')}
                          </Link>
                        )
                      })}
                    </TextStyle>
                  </Stack>
                </Banner>
              </div>
            </Layout.Section>
          </Layout>
        </Page>
        <SendRequestFeatureModal
          active={activeRequestModal}
          handleClose={this.handleToggleRequestModal}
          handleOpenResultModal={this.handleToggleResultModal}
          featureKey="themeUpgrade"
          isThemeUpgrade
        />
        <RequestResultModal active={activeResultModal} handleClose={this.handleToggleResultModal} />
      </div>
    );
  }

  // Handle preview filter action
  handlePreview = () => {
    const themeId = _.get(this.props.location, 'state.themeId', '');
    const themeName = _.get(this.props.location, 'state.themeName', '');
    const previewUrl = getThemeReviewUrl(themeId);

    const historyState = {
      themeId,
      themeName
    };

    window.open(previewUrl, '_blank');

    history.push({
      pathname: routes.themeUpgrade.verify(),
      state: historyState
    });
  };

  handleToggleRequestModal = () => {
    this.setState(prevState => ({
      activeRequestModal: !prevState.activeRequestModal
    }));
  };

  handleToggleResultModal = () => {
    this.setState(prevState => ({
      activeResultModal: !prevState.activeResultModal
    }));
  };
}

export default withI18n()(ThemeUpgradeSuccess);
